import { IDictionary } from 'models/dictionary';

export const mergeDictionaries = (dictionaries: (IDictionary[] | null)[]): IDictionary[] => {
  let mergedDictionaries: IDictionary[] = [];
  dictionaries.forEach((dictionaryArray) => {
    if (dictionaryArray) {
      mergedDictionaries = mergedDictionaries.concat(dictionaryArray);
    }
  });
  return mergedDictionaries;
};
